var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_5:_Commitment",
    "data-name": "Stage 5: Commitment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.987,
    height: 48.672,
    viewBox: "0 0 49.987 48.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    "data-name": "Rectangle 1729",
    width: 31.557,
    height: 39.75,
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_684",
    "data-name": "Ellipse 684",
    cx: 24.994,
    cy: 24.336,
    rx: 24.994,
    ry: 24.336,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32059",
    "data-name": "Group 32059",
    transform: "translate(9.147 4.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32058",
    "data-name": "Group 32058",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13524",
    "data-name": "Path 13524",
    d: "M17.391,8.245l.164-.136,4.4-3.67c.018-.016.032-.035.048-.051l.046-.042a.966.966,0,0,0,.215-.407V3.9l.019-.1q0-.055,0-.111V3.67a.873.873,0,0,0-.148-.449V3.207L20.264.407A.941.941,0,0,0,19.68.016a.854.854,0,0,0-.268-.011H12.053a.927.927,0,0,0-.771.41L9.422,3.207v.014a.874.874,0,0,0-.148.449V3.7a.584.584,0,0,0,0,.111.91.91,0,0,1,.019.1v.037a.947.947,0,0,0,.215.407l.046.042a.629.629,0,0,0,.048.051l4.145,3.452.417.352a15.8,15.8,0,0,0,1.6,31.506v0a15.8,15.8,0,0,0,1.63-31.506M15.781,36.3h-.012a12.349,12.349,0,0,1-.007-24.7h.016a12.349,12.349,0,0,1,0,24.7",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage5);
export default __webpack_public_path__ + "static/media/stage5.b1962b15120809a24bba85558ca131e4.svg";
export { ForwardRef as ReactComponent };